import type { FC, PropsWithChildren } from 'react'

import { useAppContext } from 'AppContext'
import { ErrorFallback } from 'components/ErrorFallback'

import { AppBody } from '../AppBody'

import { Layout } from './styles'

export const AppLayout: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  ...rest
}) => {
  const { loadFailure } = useAppContext()
  return (
    <Layout {...rest}>
      <AppBody>{loadFailure ? <ErrorFallback /> : <>{children}</>}</AppBody>
    </Layout>
  )
}
